import { DateTime } from 'luxon';
import { personalList } from './Tab2Component';

export default function HtmlToDoc({ user, dcdpo, answer, informing }) {
    let date = new Date().toISOString().slice(0, 10);
    // date format: dd-mm-yyyy
    date = date.split('-').reverse().join('-');

    const company_name_th = user?.companyName;
    const nameDPOTh = dcdpo?.nameDPOTh;
    const addressDPOTh = dcdpo?.addressTh;

    const dateTobbbb = DateTime.fromISO(answer?.question102)
        .setLocale('th')
        .toLocaleString(DateTime.DATE_FULL);

    const getMappedTexts = (values, language = 'nameTh', delimiter = ', ') => {
        if (!Array.isArray(values) || !Array.isArray(personalList)) {
            return '-';
        }

        return values
            .map((value) => {
                const matchedItem = personalList.find(
                    (item) => item.key === value
                );
                return matchedItem ? matchedItem[language] : '-';
            })
            .join(delimiter);
    };

    const answer501 = informing?.answer501 ? informing.answer501 : '-';
    const answer502 = informing?.answer502 ? informing.answer502 : '';

    const body = `<div>
            <div style="text-align: center; font-size: 20px; font-weight: bold;">
                หนังสือแจ้งเหตุการละเมิดข้อมูลส่วนบุคคล (Data Breach Letter)
            </div>
            <div>วันที่ ……………………………</div>
            <div>เรียน สำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล</div>
             
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ด้วย ${company_name_th} 
                ได้ตรวจพบเหตุการละเมิดในข้อมูลส่วนบุคคลที่  ${company_name_th} 
                เก็บรักษาในฐานะผู้ควบคุมข้อมูลส่วนบุคคล ซึ่ง  ${company_name_th} 
                พิจาณาว่าเหตุดังกล่าว
                มีความเสี่ยงที่จะเกิดผลกระทบต่อสิทธิและเสรีภาพของบุคคลซึ่งเป็นเจ้าของข้อมูลส่วนบุคคล
            
             <br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;เพื่อเป็นการปฏิบัติตามความของมาตรา
                37(4) แห่งพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 
                 ${company_name_th} 
                ขอนำเรียนหนังสือแจ้งเหตุการละเมิดข้อมูลส่วนบุคคลแก่สำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล
                โดยมีรายละเอียดดังต่อไปนี้
           
            <ul>
                <div>
                    <strong>1. ลักษณะและประเภทของการละเมิดข้อมูลส่วนบุคคล
                    โดยอาจบรรยายถึงลักษณะและจำนวนเจ้าของข้อมูลส่วนบุคคลหรือลักษณะและจำนวนรายการ
                    (records) ของข้อมูลส่วนบุคคลที่เกี่ยวข้องกับการละเมิด</strong>
                    <ul>
                        <div>
                            1.1) วันเวลาที่ทราบเหตุ <br /> ${dateTobbbb}
                        </div>
                        <div>
                            1.2) ลักษณะและประเภทของการละเมิดข้อมูลส่วนบุคคล 
                            <br /> ${answer?.question105 || '-'}
                        </div>
                        <div>
                            1.3) 
                            รายละเอียดเกี่ยวกับเหตุการณ์ที่นำไปสู่การละเมิดหรือรั่วไหลของข้อมูล 
                            <br />  ${answer?.question107 || '-'} 
                        </div>
                        <div>
                            1.4) 
                            ลักษณะหรือประเภทของข้อมูลส่วนบุคคลที่เกี่ยวข้องกับการละเมิด 
                            <br />  ${getMappedTexts(answer?.question202)}
                            ${
                                answer?.question202Input
                                    ? `<br /> รายละเอียดอื่นๆ : ` +
                                      answer?.question202Input
                                    : ''
                            }
                        </div>
                        <div>
                            1.5) จำนวนผู้ได้รับผลกระทบ <br /> ${
                                answer?.question204 || '-'
                            }
                        </div>
                        <div>
                            1.6) จำนวนรายการ (records)
                            ข้อมูลส่วนบุคคลที่ได้รับผลกระทบ <br /> ${
                                answer?.question205 || '-'
                            }
                        </div>
                    </ul>
                </div>
                <div>
                   <strong>2. ชื่อ สถานที่ติดต่อ
                    และวิธีการติดต่อของเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลในกรณีที่มีเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล
                    หรือชื่อ สถานที่ติดต่อ
                    และวิธีการติดต่อของบุคคลที่ผู้ควบคุมข้อมูลส่วนบุคคลมอบหมายให้ทำหน้าที่ประสานงานและให้ข้อมูลเพิ่มเติม</strong>
                    <ul>
                        <div>
                            2.1) เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล
                            (ในกรณีที่มีเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล)
                            <br />
                            ${answer?.question404 || '-'}
                        </div>
                        <div>
                            2.2) 
                            บุคคลที่ผู้ควบคุมข้อมูลส่วนบุคคลมอบหมายให้ทำหน้าที่ประสานงานและให้ข้อมูลเพิ่มเติม
                            <br /> ${answer?.question405 || '-'}
                        </div>
                    </ul>
                </div>
                <div>
                  <strong> 3. ข้อมูลเกี่ยวกับผลกระทบที่อาจเกิดขึ้นกับเจ้าของข้อมูลส่วนบุคคลจากเหตุการณ์ละเมิดข้อมูลส่วนบุคคล</strong>
                    <ul>
                        <div>3.1) บุคคลประเภทที่ได้รับผลกระทบจากการละเมิดนี้ <br /> ${getMappedTexts(
                            answer?.question203
                        )} ${
        answer?.question203Input
            ? `<br /> รายละเอียดอื่นๆ : ` + answer?.question203Input
            : ''
    }
                        </div>
                        <div>3.2) ความร้ายแรงของผลกระทบและความเสียหายที่เกิดขึ้นหรืออาจเกิดขึ้นกับเจ้าของข้อมูลจากการละเมิดดังกล่าว <br /> ${
                            answer?.question206 || '-'
                        }
                        </div>
                         <div>3.3)	ผลกระทบในวงกว้างต่อธุรกิจหรือการดำเนินการของผู้ควบคุมข้อมูลส่วนบุคคลหรือต่อสาธารณะจากเหตุการละเมิดข้อมูลส่วนบุคคล <br /> ${
                             answer?.question207 || '-'
                         }
                         </div>
                    </ul>
                </div>
                <div>
                  <strong>4. แนวทางการเยียวยาความเสียหายของเจ้าของข้อมูลส่วนบุคคล
                    และข้อมูลโดยสังเขปเกี่ยวกับมาตรการที่ผู้ควบคุมข้อมูลส่วนบุคคลใช้หรือจะใช้เพื่อป้องกัน
                    ระงับ หรือแก้ไขเหตุการละเมิด ข้อมูลส่วนบุคคล
                    โดยอาจใช้มาตรการทางบุคลากร กระบวนการ หรือเทคโนโลยี
                    หรือมาตรการอื่นใด ที่จำเป็นและเหมาะสม
                    รวมถึงข้อแนะนำเกี่ยวกับมาตรการที่เจ้าของข้อมูลส่วนบุคคลอาจดำเนินการ
                    เพิ่มเติมเพื่อป้องกัน ระงับ
                    หรือแก้ไขเหตุการละเมิดข้อมูลส่วนบุคคล หรือเยียวยาความเสียหาย</strong>
                    <ul>
                        <div>
                        4.1) ลักษณะของระบบการจัดเก็บข้อมูลส่วนบุคคลที่เกี่ยวข้องกับการละเมิด <br /> ${getMappedTexts(
                            answer?.question301
                        )} ${
        answer?.question301Input
            ? `<br /> รายละเอียดอื่นๆ : ` + answer?.question301Input
            : ''
    }
                        </div>
                        <div>
                          4.2) มาตรการป้องกันที่มีผลบังคับใช้ในขณะที่เกิดการละเมิด <br /> ${getMappedTexts(
                              answer?.question302
                          )} ${
        answer?.question302Input
            ? `<br /> รายละเอียดอื่นๆ : ` + answer?.question302Input
            : ''
    }
                        </div>
                          <div>
                        4.3) การดำเนินการที่ได้ดำเนินการตั้งแต่ค้นพบการละเมิดเพื่อปกป้องข้อมูลและปกป้องบุคคลที่ได้รับผลกระทบ <br /> ${
                            answer?.question305 || '-'
                        }
                        </div>
                          <div>
                     4.4) แจ้งเหตุต่อเจ้าของข้อมูลส่วนบุคคลให้ทราบแล้วหรือไม่ (เฉพาะกรณีมีความเสี่ยงสูงที่จะมีผลกระทบต่อสิทธิและเสรีภาพ ของบุคคล) <br /> ${answer501}&nbsp;&nbsp;${answer502}
                        </div>
                    </ul>
                </div>
            </ul>
            <div>
                 ${company_name_th} 
                ยินดีให้ความร่วมมือในการสอบสวนเหตุการณ์ละเมิดข้อมูลส่วนบุคคล
                โดยท่านสามารถติดต่อสำนักงานได้ที่
            </div>
             ${nameDPOTh}  <br />
           ${addressDPOTh} <br /><br />
            <div>จึงเรียนมาเพื่อโปรดพิจารณา</div>
            <br /><br /><br /><br />
            <div style="text-align: right; width: 100%;">
            <div style="text-align: center;">
             ………………………………………… <br/>
             (&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)<br/>
 ผู้อำนวยการฝ่ายเทคโนโลยีสารสนเทศ
                </div>
            </div>
        </div>
        <script type="text/javascript">
          $(document).ready(function() {
          let allElements = $('*');
          let converted = htmlDocx.asBlob(allElements.html());
          saveAs(converted, 'Data Breach Letter ${date}.docx');
          setTimeout(()=> window.close(), 100)
          });
        </script>
          `;

    return {
        html: `
    <!DOCTYPE html>
    <html>
    <head>
        <meta charset="UTF-8" />
        <title>Document</title>
        <script type="text/javascript" src="https://ajax.googleapis.com/ajax/libs/jquery/1.6.2/jquery.min.js"></script>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/FileSaver.js/2.0.5/FileSaver.min.js"></script>
        <script src="https://evidenceprime.github.io/html-docx-js/build/html-docx.js"></script>
    </head>
        <body>${body}</body>
    </html>`,
        body,
    };
}
